// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';
import MuiPagination from '@mui/material/Pagination';

// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';
import Page from '@/types/components/common/Page';

type PaginationProps = {
  pageData: Page;
};

export default function Pagination({ pageData }: PaginationProps) {
  const { isMobile } = useContext(AppConfigContext);

  const getPaginationLabel = (
    itemType: 'page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis',
    itemPage: number | null,
  ): string => {
    if (itemType === 'previous') return 'Prev';
    if (itemType === 'next') return 'Next';
    return itemPage?.toString() || '';
  };

  return (
    <Box
      className={isMobile ? 'my-8 flex justify-center' : 'border-t border-b mx-24 my-16 pt-8 pb-8 flex justify-center'}
    >
      <MuiPagination
        count={pageData.last_page}
        page={pageData.current_page}
        boundaryCount={isMobile ? 1 : 2}
        siblingCount={isMobile ? 1 : 3}
        hideNextButton={pageData.current_page === pageData.last_page || isMobile}
        hidePrevButton={pageData.current_page === 1 || isMobile}
        renderItem={(item) => {
          if (item.type === 'start-ellipsis' || item.type === 'end-ellipsis') {
            return '...';
          }
          const pageNationLink = pageData.links.find((link) => link.label === item.page?.toString());
          // URLがnullの場合はデフォルト値 '#' を使用
          const PageNationUrl =
            pageNationLink && pageNationLink.url ? pageNationLink.url.replace(/(\?.*)$/, '/$1') : '#';
          return (
            <a
              href={PageNationUrl}
              className={
                item.page === pageData.current_page
                  ? 'border-b-2 border-rf-blue text-rf-blue pb-2 px-4 font-bold'
                  : 'rf-hover-text hover:border-b-2 pb-2 px-4 border-rf-blu font-bold'
              }
            >
              {getPaginationLabel(item.type, item.page)}
            </a>
          );
        }}
      />
    </Box>
  );
}
